import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { VEHICLES_TYPES, VEHICLES_AMOUNT } from 'constants/survey';
import { connect } from 'react-redux';
import { resetFrom, updateSurvey } from 'store/actions';
import Analytics from '../../utils/analytics';

import StepperNav from 'components/StepperNav/StepperNav';
import truckImg from 'assets/images/vehicles/red-truck.png';
import carImg from 'assets/images/vehicles/car.png';
import vanImg from 'assets/images/vehicles/van.png';
import taxiImg from 'assets/images/vehicles/taxi.png';
import mixImg from 'assets/images/vehicles/mix.png';
import otherImg from 'assets/images/vehicles/other.png';

const mapStateToProps = (state) => ({
  survey: state.survey
});

const mapDispatchToProps = (dispatch) => ({
  resetFrom: (prop) => dispatch(resetFrom(prop)),
  updateSurvey: (survey) => dispatch(updateSurvey(survey))
});

class Step2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: "0",
      numberOfImages: 1,
      vehicleImage: ''
    };
  }

  componentDidMount() {
    const { t, survey } = this.props;

    let vehicleImage = undefined;
    // Set vehicle image
    switch(this.props.survey.vehicleType) {
      case t(VEHICLES_TYPES.TRUCK):
        vehicleImage = truckImg
        break;
      case t(VEHICLES_TYPES.CAR):
        vehicleImage = carImg
        break;
      case t(VEHICLES_TYPES.VAN):
        vehicleImage = vanImg
        break;
      case t(VEHICLES_TYPES.TAXI):
        vehicleImage = taxiImg
        break;
      case t(VEHICLES_TYPES.MIX):
        vehicleImage = mixImg
        break;
      case t(VEHICLES_TYPES.OTHER):
        vehicleImage = otherImg
        break;
      default:
        vehicleImage = truckImg
    }
    this.setState({vehicleImage: vehicleImage});

    // Set value from state
    if (survey.vehiclesAmount.length) {
      let amountValue;

      switch(survey.vehiclesAmount) {
        case VEHICLES_AMOUNT.ONE:
          amountValue = '0';
          break;
        case VEHICLES_AMOUNT.TWO_FIVE:
          amountValue = '1';
          break;
        case VEHICLES_AMOUNT.SIX_TEN:
          amountValue = '2';
          break;
        case VEHICLES_AMOUNT.ELEVEN_MORE:
          amountValue = '3';
          break;
        default:
          amountValue = '0';
      }

      this.setState({value: amountValue});
      this.setImageNumber(amountValue);
    }
  }

  handleChange = (event) => {
    let selectorVal = event.target.value;
    this.setState({value: selectorVal});
    this.setImageNumber(selectorVal);
  }

  setImageNumber = (selectorVal) => {
    let numberOfImages = 0;

    // Update number of vehicle images
    switch(selectorVal) {
      case '0':
        numberOfImages = 1;
        break;
      case '1':
        numberOfImages = 2;
        break;
      case '2':
      case '3':
        numberOfImages = 6;
        break;
      default:
        numberOfImages = 1;
    }

    this.setState({numberOfImages: numberOfImages});
  }

  handleSelection = (selectedVehicleAmount) => {
    const { survey, resetFrom, updateSurvey } = this.props;
    let amountLabel = '';

    switch(selectedVehicleAmount) {
      case '0':
        amountLabel = VEHICLES_AMOUNT.ONE;
        break;
      case '1':
        amountLabel = VEHICLES_AMOUNT.TWO_FIVE;
        break;
      case '2':
        amountLabel = VEHICLES_AMOUNT.SIX_TEN;
        break;
      case '3':
        amountLabel = VEHICLES_AMOUNT.ELEVEN_MORE;
        break;
      default:
        amountLabel = VEHICLES_AMOUNT.ONE;
    }

    if (!survey.vehiclesAmount.length) {
      // Update data from the last step
      const updatedSurvey = {
        ...survey,
        ...{vehiclesAmount: amountLabel},
      };

      updateSurvey(updatedSurvey);
    } else if (survey.vehiclesAmount !== amountLabel) {
      resetFrom({vehiclesAmount: amountLabel});
    }

    const filteredType = Analytics.removeAccentMarkAndUppercase(amountLabel);

    Analytics.pushData({
      eventCategory: 'recomendador starressa',
      eventAction: 'clic boton',
      eventLabel: `step2_numero de vehiculos_${filteredType}`
    });
  }

  render() {
    const { t } = this.props;
    const { numberOfImages } = this.state;
    let images = [];
    let maxLabel;

    if (this.state.value === '3') {
      maxLabel = <div className="m-step2__max-label">11+</div>
    }

    for (let i = 1; i <= numberOfImages; i++ ) {
      if (i < numberOfImages) {
        images.push(<img key={i} src={this.state.vehicleImage} className={`m-step2__image-unit is-clone clone-${i}`} alt=""/>);
      } else {
        images.push(<img key={i} src={this.state.vehicleImage} className="m-step2__image-unit main-img" alt=""/>);
      }
    }

    return (
      <section className="m-step m-step2">
        <div className="m-step__header">
          <h2 className="t-h2 m-step__title">{t('steps.step2.title')}</h2>
        </div>
        <div className="m-step m-step__content m-step2__container">
          <div className="m-step2__image-wrapper">
            {/* <div className={"m-step2__image" + (this.state.numberOfImages === 2 || this.state.numberOfImages === 6 ? ` has-${this.state.numberOfImages}-images` : '')}> */}
            <div className={`m-step2__image ${(this.state.numberOfImages === 2 || this.state.numberOfImages === 6 ? ` has-${this.state.numberOfImages}-images` : '')}`}>
              {images}
              {maxLabel}
            </div>
          </div>
          <div className="m-step2__selector">
            <div className="m-step2__input-wrapper">
              <input type="range" className='e-input-range m-step2__input' value={this.state.value} min="0" max="3" onChange={(e) => this.handleChange(e)} />
            </div>
            <ul className="m-step2__options">
              <li className={"m-step2__option t-option" + (this.state.value === '0' ? " is-active" : "")} title={t('steps.step2.quantity_selector.option1')}>{t('steps.step2.quantity_selector.option1')}</li>
              <li className={"m-step2__option t-option" + (this.state.value === '1' ? " is-active" : "")} title={t('steps.step2.quantity_selector.option2')}>{t('steps.step2.quantity_selector.option2')}</li>
              <li className={"m-step2__option t-option" + (this.state.value === '2' ? " is-active" : "")} title={t('steps.step2.quantity_selector.option3')}>{t('steps.step2.quantity_selector.option3')}</li>
              <li className={"m-step2__option t-option" + (this.state.value === '3' ? " is-active" : "")} title={t('steps.step2.quantity_selector.option4')}>{t('steps.step2.quantity_selector.option4')}</li>
            </ul>
          </div>
        </div>
        <StepperNav
          onCLickNext={() => this.handleSelection(this.state.value)} />
      </section>
    );
  }
}

const ConnectedStep2 = connect(mapStateToProps, mapDispatchToProps)(Step2);
export default withTranslation('translations')(ConnectedStep2);
